import React, { useState } from 'react';

const ServiceCard = ({ icon, title, description, details, linkTo }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const handleCardClick = () => {
    if (linkTo) {
      window.location.href = linkTo;
    }
  };

  return (
    <div className="service-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <div className="service-icon">
        <img src={icon} alt={title} className="service-icon-image" />
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <button 
        className={`service-btn ${isExpanded ? 'expanded' : ''}`}
        onClick={toggleDetails}
      >
        <img src="/images/Icon.png" alt="Toggle details" className="arrow-icon" />
      </button>
      <div className={`service-details ${isExpanded ? 'active' : ''}`}>
        {details.map((section, index) => (
          <div key={index}>
            <h4>{section.title}</h4>
            <ul>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceCard; 